var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-map',{staticStyle:{"height":"800px"},attrs:{"zoom":_vm.zoom,"center":_vm.center}},[_c('l-tile-layer',{attrs:{"url":_vm.url,"attribution":_vm.attribution}}),_c('l-geo-json',{attrs:{"geojson":_vm.geojson}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }